import { BrowserRouter, Link, Navigate, Route, Routes, useParams } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth/AuthContext';
import { ENV } from './api';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Accounts from './pages/Accounts';
import Funds from './pages/Funds';
import FundDetail from './pages/FundDetail';
import Dashboard from './pages/Dashboard';
import type { ReactNode } from 'react';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Layout>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/"
              element={
                <RequireAuth>
                  <Home />
                </RequireAuth>
              }
            />
            <Route
              path="/accounts"
              element={
                <RequireAuth>
                  <Accounts />
                </RequireAuth>
              }
            />
            <Route
              path="/accounts/:accountId/funds"
              element={
                <RequireAuth>
                  <Funds />
                </RequireAuth>
              }
            />
            <Route
              path="/accounts/:accountId/funds/:id"
              element={
                <RequireAuth>
                  <FundDetail />
                </RequireAuth>
              }
            />
            <Route
              path="/accounts/:accountId/dashboard"
              element={
                <RequireAuth>
                  <Dashboard />
                </RequireAuth>
              }
            />
            {/* Old /holdings deep links (bookmarks, emails) → dashboard. */}
            <Route path="/accounts/:accountId/holdings" element={<HoldingsRedirect />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
      </AuthProvider>
    </BrowserRouter>
  );
}

function Layout({ children }: { children: ReactNode }) {
  const { me, logout } = useAuth();
  return (
    <div
      style={{
        padding: '2rem',
        maxWidth: 1200,
        margin: '0 auto',
      }}
    >
      <header
        style={{
          borderBottom: '1px solid #ddd',
          marginBottom: '1.5rem',
          paddingBottom: '0.5rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'baseline',
        }}
      >
        <div>
          <h1 style={{ margin: 0 }}>
            <Link to="/" style={{ color: 'inherit', textDecoration: 'none' }}>
              finance
            </Link>
          </h1>
          <p style={{ margin: '0.25rem 0 0', color: '#666' }}>
            environment{' '}
            <code style={{ background: '#f3f3f3', padding: '0.1rem 0.4rem', borderRadius: 3 }}>
              {ENV}
            </code>
          </p>
        </div>
        {me && (
          <div style={{ color: '#666', display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
            <Link to="/accounts" style={{ color: 'inherit' }}>
              Households
            </Link>
            <span>{me.user.email}</span>
            <button onClick={() => logout()}>Sign out</button>
          </div>
        )}
      </header>
      {children}
    </div>
  );
}

function HoldingsRedirect() {
  const { accountId = '' } = useParams<{ accountId: string }>();
  return <Navigate to={`/accounts/${encodeURIComponent(accountId)}/dashboard`} replace />;
}

function RequireAuth({ children }: { children: ReactNode }) {
  const { loading, me } = useAuth();
  if (loading) return <p>Loading…</p>;
  if (!me) return <Navigate to="/login" replace />;
  return <>{children}</>;
}
